import React, { useState, useEffect } from "react";
import { HashLoader } from "react-spinners";
import { useParams } from "react-router-dom";
import { useEmployeeManagement } from "../context/EmployeeManagementContextHelper";
import { Avatar } from "flowbite-react";
import extractDate from "../utils/Helpers";

const PreviewEmployeePage = () => {
  const { employeeId } = useParams();
  const [loading, setLoading] = useState(true);
  const { userEmployee, getUserEmployee } = useEmployeeManagement();

  useEffect(() => {
    (async () => {
      await getUserEmployee(employeeId);
      setLoading(false);
    })();
  }, [getUserEmployee, employeeId]);

  console.log(userEmployee);

  return (
    <>
      {!loading ? (
        <div className="flex flex-col gap-4 w-full xl:w-3/4">
          <div className="w-full py-4 border-b border-[#003464]">
            <div className="flex flex-row gap-4 items-center">
              <Avatar alt="Profile Preview" rounded size={"xl"} />
              <h2 className="text-gray-900 text-xl md:text-2xl lg:text-3xl xl:text-5xl font-bold text-center">
                {userEmployee.middle_name
                  ? userEmployee.first_name +
                    " " +
                    userEmployee.middle_name +
                    " " +
                    userEmployee.last_name
                  : userEmployee.first_name + " " + userEmployee.last_name}
              </h2>
            </div>
          </div>
          <div className="flex flex-row gap-4">
            <dl className="w-full">
              <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Job Title</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.job_title}
                </dd>
              </div>
              <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Email address</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.email}
                </dd>
              </div>
              <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Date Of Birth</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {extractDate(userEmployee.encrypted_dob) + "/****"}
                </dd>
              </div>
              <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">
                  Social Security Number (<span>SSN</span>)
                </dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {"***-**-" + userEmployee.encrypted_ssn.slice(-4)}
                </dd>
              </div>
              <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">
                  Employment Status
                </dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.employment_status.charAt(0).toUpperCase() +
                    userEmployee.employment_status.slice(1)}
                </dd>
              </div>
              <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Phone Number</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.phone}
                </dd>
              </div>
              <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Address</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.address}
                </dd>
              </div>
              <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">City</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.city}
                </dd>
              </div>
              <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">State</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.state}
                </dd>
              </div>
              <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Zip Code</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.zip_code}
                </dd>
              </div>
              <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Hire Date</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.hire_date}
                </dd>
              </div>
              <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">
                  Termination Date
                </dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.termination_date}
                </dd>
              </div>
              <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Pay Period</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.pay_period.charAt(0).toUpperCase() +
                    userEmployee.pay_period.slice(1)}
                </dd>
              </div>
              <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">
                  Pay Rate
                </dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.pay_rate}
                </dd>
              </div>
              <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt class="text-sm font-medium text-gray-500">Vesting Schedule</dt>
                <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {userEmployee.vesting_schedule}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      ) : (
        <div className="flex flex-col md:flex-row items-center justify-center h-screen">
          <HashLoader
            size={"128px"}
            color="#20396F"
            loading={loading}
            speedMultiplier={2}
          />
        </div>
      )}
    </>
  );
};

export default PreviewEmployeePage;
